export default "__VITE_ASSET__uYQ9b_bm__"